// extracted by mini-css-extract-plugin
module.exports = {"section":"FormSection_section__3-fLl","sectionEmpty":"FormSection_sectionEmpty__6hmaR","sectionRounded":"FormSection_sectionRounded__2hfRt"};